import { Injectable } from '@angular/core';
import { Pack } from '../interfaces/pack';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PackCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/packs/' ;
  }

  // Create Pack
  add(record: Pack) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Pack Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Packs List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Pack Object
  update(record: Pack) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Pack>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Pack Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
